import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App.js';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './ScrollToTop.js';
import PwaButton from './PwaButton.js';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter>
      <ScrollToTop />
        <App />
        {window.location.pathname == "/dash" ? "" : <PwaButton /> }
    </BrowserRouter>
);

serviceWorkerRegistration.register({
  onUpdate: registration => {
    const waitingServiceWorker = registration.waiting

    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", event => {
        if (event.target.state === "activated") {
          if (
            window.confirm(
              "There is a new version of the app ready. Please reload to update."
            )
          ) {
            window.location.reload()
          }
        }
      })
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" })
    }
  },
});